import { KompanStore } from './KompanStore';

export type PropertyMap = Map<string, Map<string, Array<SimpleProperty>>>;

export interface SimpleProperty {
    name: string | null;
    value: string | null | undefined;
}

export interface ChangedItem {
    itemId: string;
    propClasses: Array<ChangedPropClass>;
}

interface ChangedPropClass {
    propClass: string;
    props: Array<ChangedProperty>;
}

interface ChangedProperty {
    propName: string;
    initValue: string;
    finalValue: string;
}

export function getAllArticlesChangedPropertyMap(): Array<ChangedItem> {
    const items: Array<ChangedItem> = new Array<ChangedItem>();
    const initialProperties: PropertyMap = KompanStore.getState().storedInitialProperties;
    for (const itemId of initialProperties.keys()) {
        const propClasses: Array<ChangedPropClass> | null = getArticleElement(itemId);
        if (propClasses != null) {
            items.push({
                itemId,
                propClasses
            });
        }
    }
    return items;
}

export function getArticleChangedPropertyMap(itemId: string): ChangedItem | null {
    const propClasses: Array<ChangedPropClass> | null = getArticleElement(itemId);
    if (propClasses != null) {
        return {
            itemId,
            propClasses
        };
    }

    return null;
}

function getArticleElement(itemId: string): Array<ChangedPropClass> | null {
    const initialProperties: PropertyMap = KompanStore.getState().storedInitialProperties;
    const finalProperties: PropertyMap = KompanStore.getState().storedFinalProperties;

    if (!initialProperties || !finalProperties) {
        return null;
    }

    return getPropClasses(itemId, initialProperties, finalProperties);
}

function getPropClasses(itemId: string, initialPropertiesMap: PropertyMap, finalPropertiesMap: PropertyMap): Array<ChangedPropClass> | null {
    const initialArticle: Map<string, Array<SimpleProperty>> | undefined = initialPropertiesMap.get(itemId);
    const finalArticle: Map<string, Array<SimpleProperty>> | undefined = finalPropertiesMap.get(itemId);

    if (!initialArticle || !finalArticle) {
        return null;
    }

    const propClasses: Array<ChangedPropClass> = new Array<ChangedPropClass>();
    for (const propClass of initialArticle.keys()) {
        const initialProperties: Array<SimpleProperty> | undefined = initialArticle.get(propClass);
        const finalProperties: Array<SimpleProperty> | undefined = finalArticle.get(propClass);

        if (!initialProperties || ! finalProperties) {
            continue;
        }

        propClasses.push({
            propClass: propClass,
            props: getProperties(initialProperties, finalProperties)
        });
    }

    return propClasses;
}

function getProperties(initialProperties: Array<SimpleProperty>, finalProperties: Array<SimpleProperty>): Array<ChangedProperty> {
    const props: Array<ChangedProperty> = new Array<ChangedProperty>();
    for (const initProp of initialProperties) {
        if (initProp.name == null) {
            continue;
        }
        const finalProp: SimpleProperty | undefined = finalProperties.find((value) => {
            return value.name === initProp.name;
        });
        props.push({
            propName: initProp.name,
            initValue: initProp.value!,
            finalValue: finalProp!.value!
        });
    }

    return props;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Kompan/PropertyCompare.ts